import Vue from 'vue'
import Vuex from 'vuex'
import storage from 'store'
import cli from '@/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedUser: null,
    defaultImgUrl: '/images/offers.jpg',
  },
  mutations: {
    setUser(state, user) {
      state.loggedUser = user
    },
  },
  actions: {
    async loginUser({ commit }, data) {
      let resp = await cli.post('/auth/', data)
      const { token } = resp.data
      cli.defaults.headers.common.Authorization = `Token ${token}`
      resp = await cli.get('/users/me/')
      commit('setUser', resp.data)
      storage.set('user', { token: token })
    },
    logoutUser({ commit }) {
      storage.remove('user')
      commit('setUser', null)
    },
    async refreshUser({ commit }) {
      const resp = await cli.get('/users/me/')
      commit('setUser', resp.data)
    },
  },
})
